<template>
  <slot></slot>
</template>

<script>
export default {
  methods: {

  },
  computed: {
  	me() {
			return this.$store.getters.user;
		}
  }
}
</script>

<style>

</style>
